import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'web-ui-components/lib/atoms/forms';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import TemplateName from '../TemplateName/TemplateName';
import withContent from '../../containers/withContent';
import saveAsTemplateContent from './saveAsTemplate.content';

const SaveAsTemplateToggle = ({ handleToggle, isChecked, content: { text, textBody } }) => (
	<div className="u-margin-top-2">
		<strong>
			<Checkbox
				id="is-save-as-template-checkbox"
				checked={isChecked}
				onChange={() => {
					handleToggle(!isChecked);
				}}
				label={text}
			/>
		</strong>

		<TextBody>{textBody}</TextBody>

		<div className="u-margin-top-2">{isChecked && <TemplateName />}</div>
	</div>
);

SaveAsTemplateToggle.propTypes = {
	isChecked: PropTypes.bool.isRequired,
	handleToggle: PropTypes.func.isRequired,
	content: PropTypes.shape({}),
};

export { SaveAsTemplateToggle };
export default withContent({ content: saveAsTemplateContent })(SaveAsTemplateToggle);
